import { render, staticRenderFns } from "./Steps.vue?vue&type=template&id=3ff0be82&scoped=true&"
import script from "./Steps.vue?vue&type=script&lang=ts&"
export * from "./Steps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff0be82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-cfm/mfe-cfm/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ff0be82')) {
      api.createRecord('3ff0be82', component.options)
    } else {
      api.reload('3ff0be82', component.options)
    }
    module.hot.accept("./Steps.vue?vue&type=template&id=3ff0be82&scoped=true&", function () {
      api.rerender('3ff0be82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/steps/Steps.vue"
export default component.exports